import React from "react";
import { GoldenSourceHelper } from "../../../../app/Switch_Core_React_Standards";
// 🎯 NEW: Import the inspector you just created
import UniversalDataInspector from "../../../common/parsers/UniversalDataInspector";

/**
 * XLS to Schematic View
 * - Standardized to match User Security Matrix width (using .container)
 */
export default function Workflow_XLS_2_Schema_View(props) {
  const {
    step, batches, previewData, cycleData, isSubmitting,
    onValidate, onConfirmPreview, onReject, onCycleChange, onSave, onBack
  } = props;

  return (
    <div className="page-main" data-scroll-container>
      <div className="page-main-inner">
        
        {/* 1. HERO SECTION: Mandatory Navigation Gap */}
        <section className="page-hero reveal-section" data-scroll>
          <div className="container">
            <h1 className="page-hero__title">
              XLS ➔ Schematic Workflow
            </h1>
            <p className="page-hero__lead">
              Phase {step}: {step === 1 ? "Discovery & Selection" : step === 2 ? "Structural Validation" : "Cycle Definition"}
            </p>
          </div>
        </section>

        {/* 2. MAIN CONTENT SECTION */}
        <section className="page-section px-4">
          <div className="container"> 
            <div className="row g-4">
              <div className="col-12">
                <div className="card shadow-sm border-0 bg-white">
                  <div className="card-header bg-white border-bottom p-4">
                     <h5 className="mb-0 fw-bold text-primary">Workflow Progress</h5>
                  </div>
                  <div className="card-body p-4">

                    {/* PHASE 1: DISCOVERY (Batch Selection) */}
                    {step === 1 && (
                      <div className="table-responsive">
                        <table className="table table-hover align-middle">
                          <thead className="table-light small text-uppercase">
                            <tr>
                              <th>Batch ID</th>
                              <th>Available XLSX Assets</th>
                              <th className="text-end">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {batches.map((batch, i) => (
                              <tr key={i}>
                                <td className="fw-bold">{GoldenSourceHelper.get(batch, "batchID")}</td>
                                <td>
                                  {GoldenSourceHelper.get(batch, "files")
                                    ?.filter(f => GoldenSourceHelper.get(f, "originalFileName")?.toLowerCase().endsWith(".xlsx"))
                                    .map((file, fi) => (
                                      <div key={fi} className="text-muted small">
                                        <i className="bi bi-file-earmark-excel me-1"></i>
                                        {GoldenSourceHelper.get(file, "originalFileName")}
                                      </div>
                                    ))}
                                </td>
                                <td className="text-end">
                                  <button 
                                    className="btn btn-primary btn-sm px-3 fw-bold"
                                    onClick={() => onValidate(GoldenSourceHelper.get(batch, "files").find(f => GoldenSourceHelper.get(f, "originalFileName").toLowerCase().endsWith(".xlsx")))}
                                  >
                                    Select for Analysis
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* PHASE 2: VALIDATION (Transposed Inspector Upgrade) */}
                    {step === 2 && (
                      <div className="reveal-section">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h6 className="fw-bold text-muted small text-uppercase mb-0">Analysis Result (Local Discovery)</h6>
                          <span className="badge bg-primary-subtle text-primary border border-primary-subtle">Structure Verified</span>
                        </div>

                        {/* 🎯 THE UPGRADE: Replacing <pre> with a scrollable inspector area */}
                        <div className="mb-4" style={{ maxHeight: '550px', overflowY: 'auto' }}>
                            {previewData?.worksheets?.map((ws, i) => (
                                <UniversalDataInspector key={i} worksheet={ws} />
                            ))}
                            {/* Fallback if previewData is empty */}
                            {!previewData?.worksheets && (
                                <div className="alert alert-warning small">No worksheets detected in the selected asset.</div>
                            )}
                        </div>

                        <div className="d-flex gap-3 pt-3 border-top">
                            <button className="btn btn-success fw-bold px-4 shadow-sm" onClick={onConfirmPreview}>
                                <i className="bi bi-check2-all me-2"></i>Accept & Proceed
                            </button>
                            <button className="btn btn-outline-danger px-4" onClick={onReject}>Reject Asset</button>
                        </div>
                      </div>
                    )}

                    {/* PHASE 3: CYCLE DEFINITION (Metadata) */}
                    {step === 3 && (
                      <div className="row g-4">
                        <div className="col-md-6">
                          <label className="small fw-bold text-muted text-uppercase mb-2">Valid From</label>
                          <input type="date" name="validFrom" className="form-control form-control-lg shadow-none" value={cycleData.validFrom} onChange={onCycleChange} />
                        </div>
                        <div className="col-md-6">
                          <label className="small fw-bold text-muted text-uppercase mb-2">Valid To</label>
                          <input type="date" name="validTo" className="form-control form-control-lg shadow-none" value={cycleData.validTo} onChange={onCycleChange} />
                        </div>
                        <div className="col-12">
                          <label className="small fw-bold text-muted text-uppercase mb-2">Transformation Commentary</label>
                          <textarea name="commentary" className="form-control shadow-none" rows="4" placeholder="Enter processing notes..." value={cycleData.commentary} onChange={onCycleChange}></textarea>
                        </div>
                        <div className="col-12 mt-4 pt-3 border-top">
                          <button className="btn btn-primary btn-lg w-100 fw-bold shadow-sm" disabled={isSubmitting} onClick={onSave}>
                            {isSubmitting ? (
                              <span><span className="spinner-border spinner-border-sm me-2"></span>Committing Schematic...</span>
                            ) : "Commit Schematic Transformation"}
                          </button>
                        </div>
                      </div>
                    )}

                  </div>
                </div>

                {/* 🎯 STANDARD ACTION FOOTER */}
                <div className="mt-5 pt-4 border-top d-flex justify-content-between">
                  <button 
                    type="button"
                    className="btn btn-link text-decoration-none p-0 text-secondary small d-flex align-items-center" 
                    onClick={onBack}
                  >
                    <i className="bi bi-arrow-left me-2"></i>
                    {step === 1 ? "Return to ESG Workflow Hub" : "Return to Previous Step"}
                  </button>
                  <span className="text-muted small align-self-center">
                    Workflow Status: <strong>{isSubmitting ? "Executing" : "Awaiting Input"}</strong>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}